<section class="cz-recommendations-configuration-item-dialog-component">
    <mat-dialog-title class="mat-dialog-title">
      <div class="row">
        <div class="col-xs-10">
          <h3 class="title" *ngIf="addNewItem">{{ _defaultStrings?.defaultStringArray?.$common_add_new_item | translate}}</h3>
          <h3 class="title" *ngIf="!addNewItem">{{ _defaultStrings?.defaultStringArray?.$common_edit | translate}}&nbsp;{{title}}</h3>
        </div>
        <div class="col-xs-2 end-xs">
          <button mat-button mat-dialog-close class="mat-dialog-back-button">
              <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </mat-dialog-title>
    <mat-dialog-content>
        <mat-vertical-stepper #stepper
                              [linear]="isLiner"
                              (selectionChange)="saveOnStep($event)">
          <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
          </ng-template>
          <mat-step [stepControl]="firstFormGroup">
            <form [formGroup]="firstFormGroup">
              <ng-template matStepLabel>{{ _defaultStrings?.defaultStringArray?.$recommendation_config_item_details | translate}}</ng-template>
              <div class="row">
                <div class="col-xs-6">
                  <mat-form-field class="form-field form-full-width-field">
                    <mat-label>{{ _defaultStrings?.defaultStringArray?.$recommendation_config_recomm_category | translate}}</mat-label>
                    <mat-select formControlName="categoryControl" required>
                      <mat-option *ngFor="let category of categories" [value]="category.value">{{category.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="form-field form-full-width-field">
                    <mat-label>{{ _defaultStrings?.defaultStringArray?.$recommendation_config_recomm_item | translate}}</mat-label>
                    <input matInput formControlName="itemTitleControl" required>
                  </mat-form-field>
                  <mat-form-field class="form-field form-full-width-field">
                    <mat-label>{{ _defaultStrings?.defaultStringArray?.$common_priority | translate}}</mat-label>
                    <mat-select formControlName="priorityControl" required>
                      <!-- <mat-option *ngFor="let priority of priorities" [value]="priority.value">{{ priority.name | translate}}</mat-option> -->
                      <mat-option [value]='1'>{{ _defaultStrings?.defaultStringArray?.$admin_recomm_config_item_priority_high | translate}}</mat-option>
                      <mat-option [value]='2'>{{ _defaultStrings?.defaultStringArray?.$admin_recomm_config_item_priority_medium | translate}}</mat-option>
                      <mat-option [value]='3'>{{ _defaultStrings?.defaultStringArray?.$admin_recomm_config_item_priority_low | translate}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-xs-6">
                  <div class="recommendations-img-upload">
                    <ng-container>
                      <dropzone #dropzoneRef
                                id="recommendations-image-upload-container"
                                message="{{ _defaultStrings?.defaultStringArray?.$import_upload | translate}}"
                                [useDropzoneClass]="true"
                                [placeholder]="placeholderImage"
                                [config]="dropzoneConfig"
                                (success)="uploadSuccessful($event)"
                                (error)="uploadFailed()"></dropzone>

                    </ng-container>
                    <button *ngIf="showDelete" mat-icon-button class="btn-delete" (click)="deleteImage()">
                      <mat-icon>close</mat-icon>
                    </button>
                    <div class="ada-text-container">
                      <mat-form-field class="form-field form-full-width-field">
                        <mat-label>{{_defaultStrings?.defaultStringArray?.$admin_training_ada_text || 'ADA Image Description'}}</mat-label>
                        <textarea matInput formControlName="adaTextControl" 
                          placeholder="{{_defaultStrings?.defaultStringArray?.$admin_training_ada_text_placeholder || 'Enter accessible description for the image'}}"></textarea>
                        <mat-hint>{{_defaultStrings?.defaultStringArray?.$admin_training_ada_text_hint || 'Describe the image for screen readers'}}</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <h5 class="no-margin" [ngClass]="{'text-error' : !mceValid}">{{ _defaultStrings?.defaultStringArray?.$recommendation_config_recomm_text | translate}}*</h5>
              <div class="row mce-controls">
                <div class="col-xs">
                  <editor [apiKey]="tinyApiKey"
                          formControlName="tinyMceControl"
                          [init]="editorConfig"></editor>
                </div>
              </div>
              <div>
              <div class="row">
                <div class="col-xs">
                  <button *ngIf="addNewItem"
                          mat-stroked-button
                          color="accent"
                          matStepperNext
                          (click)="saveRecommendation()">{{ _defaultStrings?.defaultStringArray?.$common_config_item_create | translate}}</button>
                  <button *ngIf="!addNewItem"
                          mat-flat-button
                          color="accent"
                          matStepperNext
                          (click)="saveRecommendation()">{{ _defaultStrings?.defaultStringArray?.$common_config_item_update | translate}}</button>
                </div>
              </div>
              </div>
            </form>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel>{{ _defaultStrings?.defaultStringArray?.$equipment_config_recommend_opt_rules | translate}}</ng-template>
            <section *ngIf="secondStepEnabled">
              <p class="no-margin">{{ _defaultStrings?.defaultStringArray?.$recommendation_config_recomm_trigger | translate}}</p>
              <div class="row">
                <div class="col-xs-12" *ngIf="ruleData">
                  <cz-recommendations-configuration-survey-rule
                    *ngFor="let rule of recommendation.rules"
                    [rule]="rule"
                    [ruleData]="ruleData"
                    (ruleSaved)="saveRule($event)"
                    (ruleDeleted)="deleteRule($event)"></cz-recommendations-configuration-survey-rule>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12" *ngIf="ruleData">
                  <cz-recommendations-configuration-survey-rule
                    [rule]="undefined"
                    [ruleData]="ruleData"
                    (ruleSaved)="saveRule($event)"></cz-recommendations-configuration-survey-rule>
                </div>
              </div>
              <div>
                <button mat-button matStepperPrevious class="btn-back"><mat-icon>arrow_upward</mat-icon> {{ _defaultStrings?.defaultStringArray?.$recommendation_config_recomm_back_to_details | translate}}</button>
              </div>
            </section>
            <section *ngIf="!secondStepEnabled">
                <p class="no-margin text-error">{{ _defaultStrings?.defaultStringArray?.$recommendation_config_recomm_rules_error | translate}}</p>
            </section>
          </mat-step>
           <!-- step 3 -->
          <mat-step [stepControl]="thirdFormGroup">
            <ng-template matStepLabel>{{_defaultStrings?.defaultStringArray?.$admin_tranlsations | translate}}</ng-template>
            <section *ngIf="thirdStepEnabled">
              <p *ngIf="supportedlanguage.length==1">{{_defaultStrings?.defaultStringArray?.$admin_no_translation | translate}}</p>
              <div class="col-xs-12" *ngIf="supportedlanguage.length>1">
                <div class="end-xs" *ngIf="supportedlanguage.length>1">
                  <button mat-button (click)="openAll()" *ngIf="!panelOpenState"
                    [innerHTML]="_defaultStrings?.defaultStringArray?.$btn_expand_all | translate"></button>
                  <button mat-button (click)="closeAll()" *ngIf="panelOpenState"
                    [innerHTML]="_defaultStrings?.defaultStringArray?.$btn_collapse_all | translate"></button>
                </div>
                <mat-accordion #recommendationItemsAccordion="matAccordion" multi="true" class="training-review-panels">
                  <div *ngFor="let row of addForm.get('rows')?.controls;let index = index;">
                    <mat-expansion-panel [expanded]="step===index || panelOpenState" (click)="updateStep(index)"
                    (opened)="isSubmitted = false">
                    <mat-expansion-panel-header>
                      <mat-panel-title class="truncate">{{getLanguageeName(row.get('languageId').value)}}<span
                          *ngIf="defaultLanguage === row.get('languageId').value">*</span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-form-field class="invisible example-full-width">
                      <input matInput required [formControl]="row.get('languageId')" />
                    </mat-form-field>
                    <div class="row">
                      <div class="col-xs">
                        <mat-form-field class="form-field form-full-width-field" [ngClass]="{'mat-form-field-invalid
                        ' : (row.get('title').touched || isSubmitted) 
                         && row.get('title').errors?.required}">
                          <mat-label>{{_defaultStrings?.defaultStringArray?.$recommendation_config_recomm_item | translate}}</mat-label>
                          <input required matInput [formControl]="row.get('title')"  [errorStateMatcher]="validate">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs">
                        <h5 class="no-margin" [ngClass]="{'text-error' : row.controls.text.invalid && isSubmitted}">
                          {{_defaultStrings?.defaultStringArray?.$recommendation_config_recomm_text | translate}}*</h5>
                         
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs">
                        <editor [formControl]="row.get('text')" [apiKey]="tinyApiKey" [init]="editorConfig">
                        </editor>
                      </div>
                    </div>
                    <div class="row">
                       <div class="col-xs">
                      <button class="updateButton" mat-stroked-button mat-flat-button color="accent"
                      (click)="saveItemMultilan(row.get('languageId').value, row,true)" matStepperNext
                      *ngIf="supportedlanguage.length>1">{{_defaultStrings?.defaultStringArray?.$common_config_item_update
                      | translate}}</button>
                      </div>
                    </div>
                    </mat-expansion-panel>
                  </div>
                </mat-accordion>
              </div>
              <div>
                <button mat-button matStepperPrevious class="btn-back"><mat-icon>arrow_upward</mat-icon> {{_defaultStrings?.defaultStringArray?.$recommendation_config_recomm_back_to_details | translate}}</button>
              </div>
            </section>
            <section *ngIf="!thirdStepEnabled">
                <p class="no-margin text-error">{{_defaultStrings?.defaultStringArray?.$recommendation_config_recomm_rules_error | translate}}</p>
            </section>
          </mat-step>
          <!-- step 3 -->
          </mat-vertical-stepper>
    </mat-dialog-content>
    <mat-actions>
      <div class="row">
        <div class="col-xs">
          <button mat-button color="error" *ngIf="!addNewItem" (click)="deleteItem()">{{ _defaultStrings?.defaultStringArray?.$common_delete_item | translate}}</button>
        </div>
        <div class="col-xs end-xs">
          <button mat-flat-button color="accent" mat-dialog-close>{{ _defaultStrings?.defaultStringArray?.$btn_done | translate}}</button>
        </div>
      </div>
    </mat-actions>
  </section>